
//Représente les paramètres de récupération des informations d’une recherche
export class ASeRetournerInformationsRechercheParametres 
{
  //Identifiant
  public identifiant!: string;
}

//Représente les informations d’une recherche
export class ASeInformationsRecherche 
{
	//Nom
	public nom!: string;

    //Taille d’une page
  public taillePage!: number;

  //Taille du bandeau
	public tailleBandeau!: number | null;
}
